import { QghTicker }    from './ticker.js';
import { QghCarousel }  from './carousel.js';
import { QghStandings } from './standings.js';
import { QghBracket }   from './bracket.js';
import { QghTeam }      from './team.js';

if (!customElements.get('qgh-ticker'))    customElements.define('qgh-ticker',    QghTicker);
if (!customElements.get('qgh-carousel'))  customElements.define('qgh-carousel',  QghCarousel);
if (!customElements.get('qgh-standings')) customElements.define('qgh-standings', QghStandings);
if (!customElements.get('qgh-bracket'))   customElements.define('qgh-bracket',   QghBracket);
if (!customElements.get('qgh-team'))      customElements.define('qgh-team',      QghTeam);
